import type { GetStaticProps } from 'next';
import { fetchBlogPosts } from '../../utils/api/fetchStrapiData';
import { BlogPage } from '../../views/blogPage';

export const getStaticProps: GetStaticProps = async () => {
  const blogPosts = await fetchBlogPosts();

  const categories = blogPosts.reduce<string[]>((acc, post) => {
    if (post.category) {
      post.category.forEach((category) => {
        const categoryName = category?.name?.trim();

        if (categoryName && !acc.includes(categoryName)) {
          acc.push(categoryName);
        }
      });
    }
    return acc;
  }, []);

  return {
    props: {
      blogPosts,
      categories,
    },
  };
};

export default BlogPage;
